import React, { useRef } from "react";

import { Layout, Responsive, WidthProvider } from "react-grid-layout";
import "react-grid-layout/css/styles.css";
import "./overridden-placeholder.css";

import GridItemContainer from "../../../container/overview/GridItem";
import { SupplyChainOverviewConfigure } from "../../../models/supply.chain.overview.configure";
import { useSupplyChainOverviewContext } from "../../DashMetrics/SupplyChainOverview/context";
import useStyles from "./style";

const ResponsiveGridLayout = WidthProvider(Responsive);

interface Props {
  panel: keyof SupplyChainOverviewConfigure;
}

const OverviewGridLayout = ({ panel }: Props) => {
  const classes = useStyles();
  const { getConfigByPanel, handleLayoutChange } = useSupplyChainOverviewContext();

  const config = getConfigByPanel(panel);
  const { layouts } = config;

  const ref = useRef<HTMLDivElement>(null);

  return (
    <ResponsiveGridLayout
      breakpoints={{ md: 992 }}
      className="layout"
      cols={{ lg: 6, md: 6, sm: 6, xs: 6, xxs: 6 }}
      containerPadding={[0, 24]}
      draggableHandle=".drag-handle"
      isBounded
      isDraggable
      isResizable
      layouts={layouts}
      margin={[24, 24]}
      onLayoutChange={(_current, all) => handleLayoutChange(panel, all)}
      resizeHandles={["se"]}
      rowHeight={148}
      useCSSTransforms={false}
    >
      {layouts.md.map((layout: Layout) => {
        const enabled = config[layout.i as keyof typeof config];

        if (!enabled) return null;

        return (
          <GridItemContainer
            className={classes.itemContainer}
            key={layout.i}
            panel={panel}
            ref={ref}
            widget={layout.i}
          />
        );
      })}
    </ResponsiveGridLayout>
  );
};

export default OverviewGridLayout;
